import { isStringNotEmpty } from '../../../../../NonReact/utils/GlobalFunctions'

export const createExternalScript = (src: Nullable<string>): Nullable<HTMLScriptElement> => {
    if (!isStringNotEmpty(src)) return null

    const script: HTMLScriptElement = document.createElement('script')
    script.src = src
    script.async = true

    return script
}

export const createExternalCss = (href: Nullable<string>): Nullable<HTMLLinkElement> => {
    if (!isStringNotEmpty(href)) return null

    const css: HTMLLinkElement = document.createElement('link')
    css.rel = 'stylesheet'
    css.href = href

    return css
}
